<template>
    <div class="de-active-bubble" ref="activeBubble"></div>
</template>

<script>
import BubbleCanvas from "./activeBubble.ts";

let bubbleObject = null;
export default {
    name: 'de-active-bubble',
    props: {
        data: {
            type: [Object, Array]
        }
    },
    watch: {
        data: {
            handler(v) {
                if (v) {
                    bubbleObject && bubbleObject.destroy();
                    bubbleObject = new BubbleCanvas(this.$refs.activeBubble);
                    const data = this.data.map((item) => {
                        const r = 40 + Math.floor(((item.count - 200) / 200) * 25);
                        return {
                            name: item.name,
                            r
                        };
                    });
                    bubbleObject.setData(data);
                }
            },
            immediate: true,
            deep: true
        }
    },
    destroyed() {
        bubbleObject.destroy();
        bubbleObject = null;
    }
}
</script>

<style lang="less">
.de-active-bubble {

}
</style>